import React, { useContext, useState } from "react"
import classnames from "classnames"
import { Canvas } from "react-three-fiber"
import { useInView } from "react-intersection-observer"
import { ThemeContext } from "../layout"
import { ContactModelRenderer } from "./ContactModelRender"
import HeroWrapper from "../HeroWrapper"
import { socialLinks } from "./socialLinks"
import contactme from "../../images/contactme.svg"

function Contact3d({ modelData, theme, inView, isLinkHovered }) {
  return (
    <Canvas
      gl={{ alpha: false }}
      camera={{
        position: [0, 0, 4.5],
      }}
    >
      <ambientLight intensity={0.5} />
      <pointLight position={[10, 10, 10]} />
      <ContactModelRenderer
        {...modelData}
        theme={theme}
        inView={inView}
        isLinkHovered={isLinkHovered}
      />
    </Canvas>
  )
}

function ContactMe({ modelData, showModel }) {
  const theme = useContext(ThemeContext)
  const [ref, inView] = useInView({
    threshold: 0.05,
  })
  const [isLinkHovered, toggleLinkHovered] = useState(false)

  return (
    <HeroWrapper id="contactme" theme={theme}>
      <div ref={ref} className="hero-body">
        <div
          className={classnames("contact-canvas-bg", {
            "bg-dark": theme === "dark",
          })}
        />
        <div className="container contact-me">
          <div className="columns is-vcentered">
            {showModel && (
              <div className="column is-one-third">
                <div className="contact-me-canvas">
                  <Contact3d
                    modelData={modelData}
                    theme={theme}
                    inView={inView}
                    isLinkHovered={isLinkHovered}
                  />
                </div>
              </div>
            )}
            <div className="column has-text-right">
              <figure className="image is-square is-hidden-tablet">
                <img src={contactme} alt="contact-me" />
              </figure>
              <h1 className="title is-1">Get in touch</h1>
              <a
                href="mailto:n.sharma1396@gmail.com"
                title="Send an email"
                onMouseEnter={() => toggleLinkHovered(true)}
                onMouseOut={() => toggleLinkHovered(false)}
                style={{ display: "inline-block" }}
              >
                <h4 className="title is-size-4 is-size-5-mobile has-text-weight-medium">
                  {/* n.sharma1396@gmail.com */}
                  me@nsharma.dev
                </h4>

                {/* <h4 className="title is-size-4 is-size-5-mobile has-text-weight-medium">
                  n.sharma1396@gmail.com
                </h4> */}
              </a>
              <div className="social-links">
                {socialLinks.map(socialLink => {
                  const Icon = socialLink.icon
                  return (
                    <a
                      key={socialLink.href}
                      href={socialLink.href}
                      target="_blank"
                      title={`Connect on ${socialLink.name}`}
                      rel="noopener noreferrer"
                      className={classnames(
                        "icon is-size-4",
                        theme === "light" ? "has-text-dark" : "has-text-light"
                      )}
                      onMouseEnter={() => toggleLinkHovered(true)}
                      onMouseOut={() => toggleLinkHovered(false)}
                    >
                      <Icon />
                    </a>
                  )
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
    </HeroWrapper>
  )
}

export default ContactMe
